/* istanbul ignore file */
import React from 'react';
import { useInvoiceUrl } from 'domain/finance/invoice/shared/useInvoiceRouting';
import { CREATE_INVOICE } from 'domain/finance/invoice/useInvoiceService';
import { CreateButton } from 'framework/ui/ui-builder';

const CreateInvoiceButton = () => {
  const { getCreateUrl } = useInvoiceUrl();

  return (
    <CreateButton url={getCreateUrl()} label="Add invoice" key="create-invoice" permissionToCheck={CREATE_INVOICE} />
  );
};

export default CreateInvoiceButton;
